import { Typography } from '@mui/material';
import React from 'react';

import ParagraphTag from '../../../../components/common/paragraph-tag';

type Subseccion = {
  subtitulo: string;
  contenido: string;
};

type TabSectionData = {
  titulo: string;
  secciones: Subseccion[];
};

type TabSectionProps = {
  data: TabSectionData;
};

const TabSection = ({ data }: TabSectionProps) => (
  <>
    <Typography variant="h6" style={{ marginBottom: 16 }}>
      {data.titulo}
    </Typography>

    {data.secciones.map((subseccion, index) => (
      <React.Fragment key={`${subseccion.subtitulo}`}>
        {subseccion.subtitulo && (
          <Typography
            variant="subtitle1"
            style={{ fontWeight: 500, marginBottom: 8 }}
          >
            {subseccion.subtitulo}
          </Typography>
        )}
        <ParagraphTag text={subseccion.contenido} />
      </React.Fragment>
    ))}
  </>
);

export default TabSection;
